import { uniqueId } from 'lodash';
import MultiCheckboxField from '../../../../components/FormikFields/MultiCheckboxField';

export const dataFieldFormConfig = ({ t }) => [
  {
    id: uniqueId(),
    fields: [
      {
        name: 'invoiceDetails',
        label: t('invoice_statement.invoice_details'),
        component: MultiCheckboxField,
        componentProps: {
          options: INVOICE_DETAILS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
      {
        name: 'currencyDetails',
        label: t('invoice_statement.currency_details'),
        component: MultiCheckboxField,
        componentProps: {
          options: CURRENCY_DETAILS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
      {
        name: 'sellerDetails',
        label: t('invoice_statement.seller_details'),
        component: MultiCheckboxField,
        componentProps: {
          options: SELLER_DETAILS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
      {
        name: 'buyerDetails',
        label: t('invoice_statement.buyer_details'),
        component: MultiCheckboxField,
        componentProps: {
          options: BUYER_DETAILS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
    ],
  },
  {
    id: uniqueId(),
    fields: [
      {
        name: 'supplies',
        label: t('invoice_statement.supplies'),
        component: MultiCheckboxField,
        componentProps: {
          options: SUPPLIES({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
    ],
  },
  {
    id: uniqueId(),
    fields: [
      {
        name: 'amounts',
        label: t('invoice_statement.amount_and_totals'),
        component: MultiCheckboxField,
        componentProps: {
          options: AMOUNTS_AND_TOTALS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
      {
        name: 'amountsLocal',
        label: t('invoice_statement.amount_and_totals_local'),
        component: MultiCheckboxField,
        componentProps: {
          options: AMOUNTS_AND_TOTALS_LOCAL({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
      {
        name: 'thirdPartyDetails',
        label: t('invoice_statement.third_party_details'),
        component: MultiCheckboxField,
        componentProps: {
          options: THIRD_PARTY_DETAILS({ t }),
          className: 'd-flex flex-column flex-wrap gap-3',
        },
      },
    ],
  },
];

const INVOICE_DETAILS = ({ t }) => [
  { name: 'E_INVOICE_NUMBER', label: t('invoice_statement.e_invoice_number') },
  {
    name: 'UNIQUE_DOCUMENT_IDENTIFIER',
    label: t('invoice_statement.unique_document_identifier'),
  },
  {
    name: 'E_INVOICE_ISSUE_DATE',
    label: t('invoice_statement.e_invoice_issue_date'),
  },
  {
    name: 'E_INVOICE_ISSUE_TIME',
    label: t('invoice_statement.e_invoice_issue_time'),
  },
  { name: 'PAYMENT_DATE', label: t('invoice_statement.payment_date') },
  { name: 'SUPPLY_DATE', label: t('invoice_statement.supply_date') },
  { name: 'E_INVOICE_TYPE', label: t('invoice_statement.e_invoice_type') },
  {
    name: 'E_INVOICE_TRANSACTION_TYPE',
    label: t('invoice_statement.e_invoice_transaction_type'),
  },
];

const CURRENCY_DETAILS = ({ t }) => [
  { name: 'INVOICE_CURRENCY', label: t('invoice_statement.currency') },
  {
    name: 'CURRENCY_EXCHANGE_RATE_TO_BHD',
    label: t('invoice_statement.currency_exchange_rate_to_bhd'),
  },
];

const SELLER_DETAILS = ({ t }) => [
  { name: 'SELLER_NAME', label: t('invoice_statement.seller_name') },
  {
    name: 'SELLER_VAT_ACCOUNT_NUMBER',
    label: t('invoice_statement.seller_vat_account_number'),
  },
];

const BUYER_DETAILS = ({ t }) => [
  { name: 'BUYER_NAME', label: t('invoice_statement.buyer_name') },
  {
    name: 'BUYER_VAT_ACCOUNT_NUMBER',
    label: t('invoice_statement.buyer_vat_account_number'),
  },
];

const THIRD_PARTY_DETAILS = ({ t }) => [
  { name: 'THIRD_PARTY_NAME', label: t('invoice_statement.third_party_name') },
  { name: 'THIRD_PARTY_TIN', label: t('invoice_statement.third_party_tin') },
  {
    name: 'THIRD_PARTY_VAT_NUMBER',
    label: t('invoice_statement.third_party_vat_number'),
  },
];

const AMOUNTS_AND_TOTALS = ({ t }) => [
  {
    name: 'INVOICE_TOTAL_AMOUNT_WITHOUT_VAT',
    label: t('invoice_statement.invoice_total_amount_without_vat'),
  },
  {
    name: 'TOTAL_VAT_AMOUNT',
    label: t('invoice_statement.total_vat_amount_in_local_currency'),
  },
  {
    name: 'INVOICE_TOTAL_AMOUNT_WITH_VAT',
    label: t(
      'invoice_statement.invoice_total_amount_with_vat_in_local_currency',
    ),
  },
  { name: 'PREPAID_AMOUNT', label: t('invoice_statement.prepaid_amount') },
  { name: 'ROUNDING_AMOUNT', label: t('invoice_statement.rounding_amount') },
  {
    name: 'TOTAL_AMOUNT_DUE_FOR_PAYMENT_INCLUDING_VAT',
    label: t('invoice_statement.total_amount_due_for_payment_including_vat'),
  },
];

const AMOUNTS_AND_TOTALS_LOCAL = ({ t }) => [
  {
    name: 'TOTAL_VAT_AMOUNT_IN_BHD',
    label: t('invoice_statement.total_vat_amount_in_bhd'),
  },
  {
    name: 'INVOICE_TOTAL_AMOUNT_WITH_VAT_IN_BHD',
    label: t('invoice_statement.invoice_total_amount_with_vat_in_bhd'),
  },
];

const SUPPLIES = ({ t }) => [
  {
    name: 'STANDARD_RATED_5_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.standard_rated_5_supply_taxable_amount'),
  },
  {
    name: 'STANDARD_RATED_5_VAT_AMOUNT',
    label: t('invoice_statement.standard_rated_5_vat_amount'),
  },
  {
    name: 'STANDARD_RATED_10_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.standard_rated_10_supply_taxable_amount'),
  },
  {
    name: 'STANDARD_RATED_10_VAT_AMOUNT',
    label: t('invoice_statement.standard_rated_10_vat_amount'),
  },
  {
    name: 'ZERO_RATED_EXPORTS_SUPPLY_AMOUNT',
    label: t('invoice_statement.zero_rated_exports_supply_amount'),
  },
  {
    name: 'OTHER_ZERO_RATED_SUPPLY_AMOUNT',
    label: t('invoice_statement.other_zero_rated_supply_amount'),
  },
  {
    name: 'EXEMPT_SUPPLY_AMOUNT',
    label: t('invoice_statement.exempt_supply_amount'),
  },
  {
    name: 'DOMESTIC_REVERSE_CHARGE_VAT_10_SUPPLY_TAXABLE_AMOUNT',
    label: t(
      'invoice_statement.domestic_reverse_charge_vat_10_supply_taxable_amount',
    ),
  },
  {
    name: 'DOMESTIC_REVERSE_CHARGE_VAT_10_AMOUNT',
    label: t('invoice_statement.domestic_reverse_charge_vat_10_amount'),
  },
  {
    name: 'DOMESTIC_REVERSE_CHARGE_VAT_5_SUPPLY_TAXABLE_AMOUNT',
    label: t(
      'invoice_statement.domestic_reverse_charge_vat_5_supply_taxable_amount',
    ),
  },
  {
    name: 'DOMESTIC_REVERSE_CHARGE_VAT_5_AMOUNT',
    label: t('invoice_statement.domestic_reverse_charge_vat_5_amount'),
  },
  {
    name: 'IMPORT_RCM_5_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.import_rcm_5_supply_taxable_amount'),
  },
  {
    name: 'IMPORT_RCM_5_VAT_AMOUNT',
    label: t('invoice_statement.import_rcm_5_vat_amount'),
  },
  {
    name: 'IMPORT_RCM_10_VAT_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.import_rcm_10_vat_supply_taxable_amount'),
  },
  {
    name: 'IMPORT_RCM_10_VAT_AMOUNT',
    label: t('invoice_statement.import_rcm_10_vat_amount'),
  },
  {
    name: 'IMPORT_RCM_OTHER_0_VAT_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.import_rcm_other_0_vat_supply_taxable_amount'),
  },
  {
    name: 'IMPORT_RCM_EXEMPT_VAT_SUPPLY_TAXABLE_AMOUNT',
    label: t('invoice_statement.import_rcm_exempt_vat_supply_taxable_amount'),
  },
];
